<template>
  <div v-html="props.options.text || '--empty--'" />
</template>

<script setup lang="ts">
const props = defineProps({
  options: { type: Object, required: true },
});
</script>
